import { AdminApprovalsPage } from "./pages/admin/AdminApprovalsPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { isProductHost } from "./lib/product-host";
import { ProductPage } from "./pages/ProductPage";
import { EventIndexPage } from "./pages/EventIndexPage";
import { ReaderPage } from "./pages/ReaderPage";
import { EmbedCurrentPage } from "./pages/EmbedCurrentPage";
import { EmbedArchivePage } from "./pages/EmbedArchivePage";
import { ChatEmbedPage } from "./pages/ChatEmbedPage";
import { AppHandoffPage } from "./pages/AppHandoffPage";
import { AdminLoginPage } from "./pages/admin/AdminLoginPage";
import { AdminShell } from "./pages/admin/AdminShell";
import { AdminLivedeskPage } from "./pages/admin/AdminLivedeskPage";
import { AdminEventsPage } from "./pages/admin/AdminEventsPage";
import { AdminStatsPage } from "./pages/admin/AdminStatsPage";
import { AdminSettingsPage } from "./pages/admin/AdminSettingsPage";
import { InvitationPage } from "./pages/admin/InvitationPage";
import { ResetPasswordPage } from "./pages/admin/ResetPasswordPage";

export function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          isProductHost() ? (
            <ProductPage />
          ) : (
            <EventIndexPage fallback={<ProductPage />} />
          )
        }
      />
      <Route path="/events/:slug" element={<ReaderPage />} />
      <Route path="/embed/:slug" element={<ReaderPage embed />} />
      <Route path="/embed/current" element={<EmbedCurrentPage />} />
      <Route path="/embed/archive" element={<EmbedArchivePage />} />
      <Route path="/embed/chat/:slug" element={<ChatEmbedPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/app" element={<AppHandoffPage />} />
      <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/admin/invitation/:invitationId"
        element={<InvitationPage />}
      />
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<AdminLivedeskPage />} />
        <Route path="events" element={<AdminEventsPage />} />
        <Route path="stats" element={<AdminStatsPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="compose" element={<Navigate to="/admin" replace />} />
        <Route path="approvals" element={<AdminApprovalsPage />} />
        <Route path="chat" element={<Navigate to="/admin" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
